import { defineComponent as _defineComponent } from 'vue'
import Steps from 'primevue/steps';
import {computed, ref} from "vue";
import i18n from "@/plugins/i18n";
import router from "@/router";
import {useToast} from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPasswordView',
  setup(__props, { expose: __expose }) {
  __expose();

const currentPath = router.currentRoute.value.path;

const items = computed(()=> [
  {
    label: i18n.global.t('SIGN_IN_VIEW.EMAIL'),
    to: currentPath + ""
  },
  {
    label: i18n.global.t('SECTION_TITLES.PROVIDEVERIFICATIONCODE'),
    to: currentPath + "/step2"
  },
  {
    label: i18n.global.t('SIGN_IN_VIEW.PASSWORD'),
    to: currentPath + "/step3",
  },
]);

const nextPage = (event: {pageIndex: number}) => {
  router.push(items.value[event.pageIndex + 1].to);
};
const prevPage = (event: {pageIndex: number}) => {
  if (event.pageIndex === 0) router.back();
  else router.push(items.value[event.pageIndex - 1].to);
};
const complete = () => {
  console.log(newPassword);
  useToast().success('Password has been reset');
  router.push('/profile/signIn');
};

const newPassword = ref({
  email: '',
  password: ''
});

const __returned__ = { currentPath, items, nextPage, prevPage, complete, newPassword, get Steps() { return Steps } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})